
export default function Customers() {

    return(
        <>
          <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 h-96 mb-4">
    
          </div>
      </>
    )
    }